<template>
  <div class="main-body fill-height">
    <OnboardingNav />
    <!-- onboarding 2nd step -->
    <v-layout row wrap class="row fill-height" id="onboarding-2">
      <v-flex xs3 md3 lg3 class="flex1">
        <div class="content-area">
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-check-circle-outline</v-icon> Add a
              Brand/Location
            </p>
            <v-divider />
          </div>
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-checkbox-blank-circle-outline</v-icon>
              Add Staff
            </p>
            <v-divider />
          </div>
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-checkbox-blank-circle-outline</v-icon>
              Menu Category
            </p>
            <v-divider />
          </div>
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-checkbox-blank-circle-outline</v-icon>
              Menu Setup
            </p>
            <v-divider />
          </div>
        </div>
        <div class="footer">
          <p><router-link to="/" class="link">Exit Setup</router-link></p>
        </div>
      </v-flex>
      <v-flex xs9 md9 lg9 class="flex2">
        <div class="flex2-content">
          <h4>Add Staffs</h4>
          <span
            >You can add a staff and set roles and permissions. A staff must be
            assigned to a location or all locations. They will recieve login
            details via email. You can also upload a list of staff.
          </span>
          <div class="form-area">
            <v-form ref="onboarding2">
              <div class="form-group">
                <label for="country">Location</label>
                <v-select
                  outlined
                  v-model="location"
                  :items="getEnterpriseLocations"
                  item-text="name"
                  item-value="id"
                  dense
                  height="48"
                  label="Select Locations"
                  :rules="[rules.required]"
                ></v-select>
              </div>
              <div class="form-group">
                <v-row class="py-0">
                  <v-col cols="12" class="py-0">
                    <label for="brand name">Staff Name</label>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" class="py-0">
                    <v-text-field
                      outlined
                      v-model="firstName"
                      dense
                      height="48"
                      label="First Name"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" class="py-0">
                    <v-text-field
                      outlined
                      v-model="lastName"
                      dense
                      height="48"
                      label="Last Name"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
              <div class="form-group">
                <label for="country location">Email Address</label>
                <v-text-field
                  outlined
                  v-model="email"
                  dense
                  height="48"
                  label="email"
                  :rules="[rules.required, rules.email]"
                ></v-text-field>
              </div>
              <div class="form-group">
                <label for="country">Roles</label>
                <v-select
                  outlined
                  v-model="role"
                  :items="userTypes"
                  item-text="name"
                  item-value="id"
                  dense
                  height="48"
                  label="Select Role"
                  :rules="[rules.required]"
                ></v-select>
              </div>
            </v-form>
            <div>
              <v-layout row wrap style="margin-top: 4%">
                <v-flex xs2 md2 lg2>
                  <v-btn><v-icon>mdi-step-backward</v-icon></v-btn>
                </v-flex>
                <v-flex xs2 md6 lg6>
                  <strong style="font-size: 16px"
                    >if you can't find a role that fits, click here to add a new
                    role</strong
                  >
                </v-flex>
                <v-flex xs6 md4 lg4>
                  <v-btn
                    class="success"
                    :loading="nextLoading"
                    id="next-btn"
                    @click="processNextStage"
                    >Next</v-btn
                  >
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import { mapState } from "vuex";
import OnboardingNav from "../../components/onboarding/OnboardingNav";
import axios from "axios";
export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      role: "",
      nextLoading: false,
      location: "",
      email: "",
      isStaffAdded: "",
      rules: {
        required: (value) => !!value || "Required",
        email: (value) =>
          !value ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
          "Invalid E-mail",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
    };
  },
  methods: {
    async processNextStage() {
      if (this.$refs.onboarding2.validate()) {
        await this.addStaff();

        if (this.isStaffAdded == true) {
          await this.updateMeta();

          // Goto next state
          setTimeout(() => {
            this.$router.push("/onboarding-3");
            this.nextLoading = false;
          }, 1000);
        }
      }
    },
    async addStaff() {
      this.nextLoading = true;

      const data = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        userType: this.role,
        locationId: this.location,
        isOnboarding: true,
      };
      await axios
        .post("/api/v1/staff", data, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          this.isStaffAdded = true;
        })
        .catch((error) => {
          this.snackBar.active = true;
          this.snackBar.text = error.response.data.message || "Staff not added";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          this.isStaffAdded = false;
          this.nextLoading = false;
        });
    },
    async updateMeta() {
      let meta = this.storedUserDetails.meta;
      meta.onboarding.stage = 2;
      meta.onboarding.status = "incomplete";

      await this.$store
        .dispatch("updateUserProfile", { meta: meta })
        .then(() => {
          this.snackBar.active = true;
          this.snackBar.text = "Great! Staff Added";
          this.snackBar.color = "success";
          this.snackBar.timeout = this.$store.state.snackBarDuration;
        })
        .catch((error) => {
          this.snackBar.active = true;
          this.snackBar.text = error.response.data.message || "Staff not added";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          return error.response.status;
        });
    },
  },
  computed: {
    ...mapState([
      "storedUserDetails",
      "enterpriseDetails",
      "enterpriseLocations",
      "userTypes",
    ]),
    getEnterpriseLocations() {
      const locationArr = this.enterpriseLocations;

      const newLocationArr = [];
      locationArr.forEach((loc) => {
        newLocationArr.push({ id: loc.id, name: loc.locationName });
      });

      return newLocationArr;
    },
  },
  created() {
    this.$store.dispatch("getUserDetails");
    this.$store.dispatch("getEnterpriseDetails");
  },
  components: {
    OnboardingNav,
  },
};
</script>

<style scoped>
.main-body {
  font-family: "Montserrat";
}

.flex2 {
  padding-top: 3%;
  background: white;
}

.flex2-content {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
}

.content-area {
  padding-top: 15%;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  color: white;
}

.footer {
  padding-top: 70%;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  color: white;
}

.icon {
  color: green;
  margin-right: 2%;
}

p {
  margin-top: 5%;
}

.link {
  color: #ffffff;
  text-decoration: none;
}

.content-list:hover {
  background: #444444;
  border-radius: 2px;
}

form {
  margin-top: 4%;
}

.form-group {
  width: 50%;
  margin-top: -1%;
}

#next-btn {
  float: right;
  text-transform: capitalize;
  width: 40%;
  height: 100%;
}

.v-text-field--outlined.v-input--dense .v-label {
  top: 14px;
}

/* @media only screen and (max-device-width: 480px) {
    .row {
        margin-top: 15%;
    }
} */
</style>
